var timer = null;
    function showMsg(str) {
        clearTimeout(timer)
        $(".common_msg").text(str)
        $(".common_msg").removeClass("hide")
        timer = setTimeout(function () {
            $(".common_msg").addClass("hide")
        }, 5000)
    }
let index={
    init(){
        this.videoInit()
        this.swiperInit()
        this.other()
        this.chooseSwiper()
    },
    videoInit(){
        TCPlayer("videoPlayerA", {
            fileID: "5285890796158373904",
            appID: "1259605108",
            autoplay: false
          });
    },
    swiperInit(){
        new Swiper('.zs_container1', {
            autoplay: true,//可选选项，自动滑动
            slidesPerView:2,
            spaceBetween:10
        })
        new Swiper('.zs_container2', {
            autoplay: true,//可选选项，自动滑动
            slidesPerView:2,
            spaceBetween:10
        })
        new Swiper('.city_container', {
            // autoplay: true,//可选选项，自动滑动
            autoplay: {
              delay: 3000,
              disableOnInteraction: false
            },
            pagination: {
              el: '.swiper-pagination',
            }
        })
        new Swiper('.teacher_container', {
          // autoplay: true,//可选选项，自动滑动
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
          }
        })
        new Swiper('.book_container', {
          // autoplay: true,//可选选项，自动滑动
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
          }
        })
        new Swiper('.jc_container', {
          // autoplay: true,//可选选项，自动滑动
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
          }
        })
        new Swiper('.act_container', {
          // autoplay: true,//可选选项，自动滑动
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        })
        // new Swiper(".swiper_course",{
        //   direction : 'vertical',
        //   slidesPerView : 5,
        //   centeredSlides:true
        // })
    },
    other(){
      $(".goSchool").click(function () {
        $("html,body").animate({
          scrollTop: $(".school_map").offset().top
        }, 500);
      });
    },
    chooseSwiper(){
      let swiper1=null
      let swiper2=null
      $(".dialog_course").click(function(){
        if(!swiper1){
          $(".swiper_box_course").show()
          new Swiper(".swiper_course",{
            direction : 'vertical',
            slidesPerView : 5,
            centeredSlides:true
          })
        }
        
      })
      $(".dialog_city").click(function(){
        if(!swiper2){
          $(".swiper_box_city").show()
          new Swiper(".swiper_city",{
            direction : 'vertical',
            slidesPerView : 5,
            centeredSlides:true
          })
        }
        
      })
      $(".swiper_submit").click(function(){
        let _this=$(this)
        let value= _this.parent().next().find(".swiper-slide.swiper-slide-active").text()
        if(_this.hasClass("course_submit")){
          
          $(".input_course").val(value)
        }else{
          $(".input_city").val(value)
        }
        $(".swiper_box").hide()
      })
      $(".swiper_cancle").click(function(){
        $(".swiper_box").hide()
      })
      $(".commom_btn").click(function(){
        $("body").addClass("auto-fixed")
        if($(this).hasClass("sign2")){
          $(".dialog_2").show()
        }else(
          $(".dialog_1").show()
        )
      })
      $(".dialog_close").click(function(){
        $(".dialog_box").hide()
        $("body").removeClass("auto-fixed")
      })
      $('.dialog_1').listenForm({
        contentName: '暑假班m弹出表单',
        submitTarget: '.submit1',
        courseRequired: true,
        cityRequired: true,
        successFun: function successFun() {
          showMsg('恭喜您的试听申请已提交成功,我们的专业顾问将在1-3个工作日内与您联系、安排试听，请您保持电话畅通！')
          $(".dialog_input").val("")
          // $(".alert-test").show();
        }
      });
      $('.dialog_2').listenForm({
        contentName: '暑假班m弹出表单',
        submitTarget: '.submit2',
        courseRequired: true,
        cityRequired: true,
        isMsg: true,
        smsInfo: '【新航道】新航道烤鸭大礼包领取链接: https://pan.baidu.com/s/1Fm84dZaGjzO8Twu-BL-m9A 提取码: jsen 复制这段内容后打开百度网盘手机App，操作更方便哦。',
        successFun: function successFun() {
          showMsg('申领成功，请注意查收手机短信，按提示操作领取')
          $(".dialog_input").val("")
          // $(".alert-test").show();
        }
      });
    }
}
index.init()